import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import Checkbox from "../../../shared/custom-components/checkbox";
import Table from "../../../shared/table";
import TableActions from "./tableActions";
import useApi from "../../../hooks/useApi";
import { loadingModal } from "../../../utils/functions";
import { LABELS_ACCOUNT_TYPE } from "../../../shared/AccountTypeSelect";

const AddAccount = ({ changeStep, providerId, updateAccount }) => {
  const [state, setState] = useState({
    data: [],
    page: 0,
    totalSize: 0,
    sizePerPage: 10,
    isReady: false,
  });

  const [selectedAccount, setSelectedAccount] = useState(null);
  const [loading, setLoading] = useState(false);

  const { cancellCall, getApiCAll } = useApi();
  const { t } = useTranslation();

  const handleSelect = (item) => {
    setSelectedAccount(item);
  };

  const getData = async () => {
    setLoading(true);
    try {
      const {
        data: { data },
      } = await getApiCAll(
        `/providers/provider-account-temp-list/${providerId}`,
        undefined,
        { page: state.page, size: state.sizePerPage }
      );

      setState({
        ...state,
        data: data.content.map(({ accountType, ...restItem }) => ({
          ...restItem,
          accountType: LABELS_ACCOUNT_TYPE[accountType],
        })),
        totalSize: data.totalElements,
        isReady: true,
      });
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();

    return () => cancellCall();
  }, [state.page]);

  const checkboxItem = ({ id, accountCurrency }) => {
    const checked = selectedAccount?.id === id;
    return (
      <Checkbox
        checked={checked}
        disabled={!checked && selectedAccount}
        onChange={() => handleSelect(checked ? null : { id, accountCurrency })}
      />
    );
  };

  const onTableChange = (params) => {
    setState({ ...state, ...params });
    return Promise.resolve();
  };

  return (
    <>
      {state.isReady && (
        <Table
          {...state}
          onTableChange={onTableChange}
          headers={getHeaders(t, checkboxItem)}
          actions={
            <TableActions
              firstButton={{
                onClick: () => changeStep(1),
                label: t("general.special_codition.BACK"),
              }}
              secondButton={{
                onClick: () => {
                  updateAccount(selectedAccount);
                  changeStep(3);
                },
                label: t("general.special_codition.NEXT"),
                disabled: !selectedAccount,
              }}
            />
          }
        />
      )}
      {loading && loadingModal()}
    </>
  );
};

export default AddAccount;

const getHeaders = (t, cellFormatter) => {
  return [
    {
      selector: "checkbox",
      center: true,
      name: "",
      bodyStyle: { flexGrow: 0 },
      grow: 0,
      cellFormatter,
    },
    {
      selector: "coutryCodeCompany",
      name: t("providers.table.headers.country"),
    },
    {
      selector: "accountType",
      name: t("providers.table.headers.requestType"),
    },
    {
      selector: "accountCurrency",
      name: t("providers.table.headers.divisa"),
    },
    {
      selector: "accountNumber",
      name: t("providers.table.headers.providerAccount"),
    },
  ];
};
